// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"44fb7bb6","453":"54a4c12d"}[chunkId] + ".chunk.js";
};